// Build a "Add to Google Calendar" template link. Saving the event on
// tecgsoftware@gmail.com adds a Google Meet link automatically (if the account's
// "auto-add Google Meet" setting is on).
export const GCAL_ACCOUNT = 'tecgsoftware@gmail.com';

const stamp = (d) => d.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, ''); // -> 20260815T100000Z

export function buildCalendarUrl({ title, date, time, durationMin = 30, details = '', guests = [] }) {
  if (!date) return '';
  const start = new Date(`${date}T${(time || '10:00')}:00`);
  if (isNaN(start.getTime())) return '';
  const end = new Date(start.getTime() + durationMin * 60000);
  const p = new URLSearchParams({
    action: 'TEMPLATE',
    text: title || 'Meeting',
    dates: `${stamp(start)}/${stamp(end)}`,
    details: (details ? details + '\n\n' : '') + 'Tip: click Save — Google Meet is added automatically.',
    authuser: GCAL_ACCOUNT,
  });
  (guests || []).filter(Boolean).forEach((g) => p.append('add', g));
  return `https://calendar.google.com/calendar/render?${p.toString()}`;
}

// types that are treated as meetings (need a time + calendar link)
export const isMeeting = (t) => t === 'meeting' || t === 'demo';
